import { Payment } from '@guiker/base-entity'
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export import CountryCode = Payment.SupportedCountries
